import React from "react";
import { observer } from "mobx-react-lite";
import { FormGroup, Checkbox } from "@blueprintjs/core";
import { ICheckboxEditorProps, EditorWithFormGroup } from "./_types";

// CheckboxAttrEditor
export const CheckboxAttrEditor = observer(<D, K extends keyof D>(props: ICheckboxEditorProps<D, K>) => {
	const { store, checkboxProps, name } = props;

	// Change handler
	const _onChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
		if (props.checkboxProps?.onChange) props.checkboxProps.onChange(ev);
		else store.toggle(props.name);
	};

	// --

	return <Checkbox onChange={_onChange} checked={!!store.data[name]} {...checkboxProps} name={props.name as string} />;
});

// CheckboxAttrEditorGroup
export const CheckboxAttrEditorGroup = <D, K extends keyof D>(props: EditorWithFormGroup<ICheckboxEditorProps<D, K>>) => {
	const { formGroupProps, ...rest } = props;

	return (
		<FormGroup {...formGroupProps}>
			<CheckboxAttrEditor {...rest} />
		</FormGroup>
	);
};
